// import _ from 'lodash'
import axios from "@/axios";
export default {
  isNull: function (val) {
    return _.isUndefined(val) || _.isNull(val);
  },

  isEmpty: function (s) {
    if (!_.isString(s)) return false;
    if (s == null || s === "") {
      return true;
    }
    return false;
  },

  //입력된 문자열이 숫자와 알파벳로만 구성되어있는지 체크
  isAlphaNumeric: function (s) {
    if (!_.isString(s)) return false;
    return /^[A-Za-z0-9]+$/.test(s);
  },

  //입력된 문자열이 숫자로만 구성되어있는지 체크
  isNumeric: function (s) {
    if (!_.isString(s)) return false;
    return /^[0-9]+$/.test(s);
  },

  //생년월일 체크
  isValidDateFormat: function (data) {
    var format = /[12][0-9]{3}-[0-9]{2}-[0-9]{2}/;
    if (data.search(format) == -1) return false;

    var _year = data.substr(0, 4);
    var _month = data.substr(5, 2);
    var _day = data.substr(8, 2);

    return this.isValidDate(_year, _month, _day);
  },

  isValidDate: function (y, m, d) {
    var year, month, day;
    var days = new Array(31, 0, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);

    y = y.trim();
    m = m.trim();
    d = d.trim();
    if (y.length != 4 || m.length != 2 || d.length != 2) return false;

    year = parseInt(y);

    if (m.charAt(0) == "0") m = m.charAt(1);
    month = parseInt(m);

    if (d.charAt(0) == "0") d = d.charAt(1);
    day = parseInt(d);

    if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) days[1] = 29;
    else days[1] = 28;

    if (month < 1 || month > 12) return false;

    if (day < 1 || day > days[month - 1]) return false;

    return true;
  },

  //입력된 문자열이 알파벳로만 구성되어있는지 체크
  isAlpha: function (s) {
    if (!_.isString(s)) return false;
    return /^[A-Za-z]+$/.test(s);
  },

  //입력된 문자열이 한글로만 구성되어 있는지 체크
  isHangul: function (s) {
    if (!_.isString(s)) return false;
    return /^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]+$/.test(s);
  },

  //해당하는 문자열에 대한 길이 반환
  getLength: function (s) {
    if (!_.isString(s)) return 0;
    return s.length;
  },

  //해당하는 문자열에 대해서 byte 단위에 대해서 길이 계산해서 총 길이 반환
  //한글은 3Byte
  getByteLength: function (s) {
    if (!_.isString(s)) return 0;
    var b,
      i,
      c = 0;
    for (b = i = 0; (c = s.charCodeAt(i++)); b += c >> 11 ? 3 : c >> 7 ? 2 : 1);
    return b;
  },

  //문자열의 왼쪽의 공백 문자열 제거
  leftTrim: function (s) {
    if (!_.isString(s)) return "";
    return s.replace(/^\s+/, "");
  },

  //문자열의 오른쪽의 공백 문자열 제거
  rightTrim: function (s) {
    if (!_.isString(s)) return "";
    return s.replace(/\s+$/, "");
  },

  //공백제거
  cf_Trim: function (sValue) {
    if (sValue == null) return "";
    if (new String(sValue).valueOf() == "undefined") return "";
    if (new String(sValue) == null) return "";

    var retVal = new String(sValue).replace(/^\s+|\s+$/g, "");

    return retVal;
  },

  //문자열의 공백 문자열 제거
  trim: function (s) {
    if (!_.isString(s)) return "";
    return s.replace(/^\s+|\s+$/g, "");
  },

  //해당하는 문자열에 대해서 입력된 길이만큼 부족한 길이를 왼쪽부터 공백으로 채워넣는다.
  leftPad: function (s, len, c) {
    if (!_.isString(s) || !_.isString(c)) return "";
    if (!_.isNumber(len) || len <= this.getLength(s)) return s;
    if (this.getLength(c) != 1) return s;

    var padLen = len - this.getLength(s);
    for (var i = 0; i < padLen; i++) {
      s = c + s;
    }
    return s;
  },

  //해당하는 문자열에 대해서 입력된 길이만큼 부족한 길이를 오른쪽부터 지정된 문자로 채워넣는다.
  rightPad: function (s, len, c) {
    if (!_.isString(s) || !_.isString(c)) return "";
    if (!_.isNumber(len) || len <= this.getLength(s)) return s;
    if (this.getLength(c) != 1) return s;

    var padLen = len - this.getLength(s);
    for (var i = 0; i < padLen; i++) {
      s += c;
    }
    return s;
  },

  addCommas: function (s) {
    if (_.isNull(s) || _.isEmpty(s)) return "";
    if (_.isNumber(s)) s = "" + s;
    if (!_.isString(s)) return "";

    var x,
      x1,
      x2 = "";
    x = s.split(".");
    x1 = x[0];
    x2 = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    return x1 + x2;
  },

  //입력된 문자열이 주어진 문자열과 일치하는 모든 문자열을 바꿔야할 문자열로 변경
  replaceAll: function (s, bs, as) {
    if (!_.isString(s) || !_.isString(bs) || !_.isString(as)) return "";
    return s.split(bs).join(as);
  },

  //HTML tag가 들어있는 문자열에 대해 unescape해준다.
  replaceHtmlEscape: function (s) {
    if (!_.isString(s)) return "";
    return _.escape(s);
  },

  //unescaped된 문자열에 대해 HTML tag 형태로 바꿔준다.
  removeEscapeChar: function (s) {
    if (!_.isString(s)) return "";
    return _.unescape(s);
  },

  //DateUtil
  //입력된 일자가 유효한 일자인지 체크
  isDate: function (s) {
    if (!_.isString(s) || this.isEmpty(s) || this.getLength(s) != 8)
      return false;

    var year = Number(s.substring(0, 4));
    var month = Number(s.substring(4, 6));
    var day = Number(s.substring(6, 8));

    if (1 > month || 12 < month) {
      return false;
    }

    var lastDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    var lastDay = lastDays[month - 1];

    if (month == 2 && ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0)) {
      lastDay = 29;
    }

    if (1 > day || lastDay < day) {
      return false;
    }

    return true;
  },

  //입력된 시간이 유효한지 체크
  isTime: function (s) {
    if (!_.isString(s) || this.isEmpty(s) || this.getLength(s) != 6)
      return false;

    var h = Number(s.substring(0, 2));
    var m = Number(s.substring(2, 4));
    var s = Number(s.substring(4, 6));

    if (0 > h || 23 < h) {
      return false;
    }

    if (0 > m || 59 < m) {
      return false;
    }

    if (0 > s || 59 < s) {
      return false;
    }

    return true;
  },

  //입력된 시간이 유효한지 체크
  isHour: function (s) {
    if (!_.isString(s) || this.isEmpty(s) || this.getLength(s) != 2)
      return false;

    var h = Number(s);

    if (0 > h || 23 < h) {
      return false;
    }

    return true;
  },

  //입력받은 일자를 Date형으로 변환
  strToDate: function (s) {
    if (!_.isString(s)) return null;

    var array = s.split(" ");
    var date = array[0];
    var time = "000000";

    if (2 == array.length) {
      time = array[1];
    }

    if (!this.isDate(date)) return null;
    if (!this.isTime(time)) return null;

    var year = date.substring(0, 4);
    var month = Number(date.substring(4, 6)) - 1;
    var day = date.substring(6, 8);
    var hour = time.substring(0, 2);
    var minute = time.substring(2, 4);
    var second = time.substring(4, 6);

    return new Date(
      year,
      this.leftPad("" + month, 2, "0"),
      day,
      hour,
      minute,
      second
    );
  },

  formatDate: function (d, f) {
    if (!_.isString(f)) return "";

    if (_.isDate(d)) {
      return f.replace(/(yyyy|yy|mm|dd|hh24|hh|mi|ss|fff|a\/p)/gi, ($1) => {
        switch ($1) {
          case "yyyy":
            return "" + d.getFullYear();
          case "yy":
            return this.leftPad(
              "" + (d.getFullYear() % 1000),
              4,
              "0"
            ).substring(2, 4);
          case "mm":
            return this.leftPad("" + (d.getMonth() + 1), 2, "0");
          case "dd":
            return this.leftPad("" + d.getDate(), 2, "0");
          case "hh24":
            return this.leftPad("" + d.getHours(), 2, "0");
          case "hh":
            return this.leftPad(
              "" + ((h = d.getHours() % 12) ? h : 12),
              2,
              "0"
            );
          case "mi":
            return this.leftPad("" + d.getMinutes(), 2, "0");
          case "ss":
            return this.leftPad("" + d.getSeconds(), 2, "0");
          case "fff":
            return this.leftPad("" + d.getMilliseconds(), 3, "0");
          case "a/p":
            return d.getHours() < 12 ? "오전" : "오후";
          default:
            return $1;
        }
      });
    } else if (_.isString(d)) {
      return this.formatDate(this.strToDate(d), f);
    }

    return "";
  },

  //성별 구하기
  getGndr: function (sJumin) {
    //  1("남 1900~1999 국내)
    //  2("여 1900~1999 국내)
    //  3("남 2000~2099 국내)
    //  4("여 2000~2099 국내)
    //  5("남 1900~1999 해외)
    //  6("여 1900~1999 해외)
    //  7("남 2000~2099 해외)
    //  8("여 2000~2099 해외)
    //  A("남 태아)
    //  B("여 태아)
    //  G("남 1900~1999 미식별 외국인)
    //  H("여 1900~1999 미식별 외국인)
    //  I("남 2000~2099 미식별 외국인)
    //  J("여 2000~2099 미식별 외국인)

    var sVal = sJumin.substr(6, 1);

    if (
      sVal == "1" ||
      sVal == "3" ||
      sVal == "5" ||
      sVal == "7" ||
      sVal == "A" ||
      sVal == "G" ||
      sVal == "I"
    ) {
      return "1";
    } else if (
      sVal == "2" ||
      sVal == "4" ||
      sVal == "6" ||
      sVal == "8" ||
      sVal == "B" ||
      sVal == "H" ||
      sVal == "J"
    ) {
      return "2";
    } else {
      return;
    }
  },

  //입력받은 일자의 요일 반환
  getDayOfWeek: function (s) {
    if (!this.isDate(s)) return "";
    var week = ["일", "월", "화", "수", "목", "금", "토"];
    return week[this.strToDate(s).getDay()];
  },

  //입력받은 두 날짜 사이의 일자 계산
  getDay: function (sd, ed) {
    if (!this.isDate(sd) || !this.isDate(ed)) return -1;
    if (Number(ed) < Number(sd)) return -2;

    var newSd = this.strToDate(sd);
    var newEd = this.strToDate(ed);
    var diffTime = newEd.getTime() - newSd.getTime();

    return Math.floor(diffTime / (1000 * 60 * 60 * 24));
  },

  //입력받은 일자에 대해서 해당 일만큼 더한 일자 반환. 마이너스 일자는 입력받은 일자보다 이전의 일자로 계산해서 반환
  addDays: function (s, d, f) {
    console.log(!this.isDate(s), !_.isNumber(d));
    if (!this.isDate(s) || !_.isNumber(d)) return "";
    var newDt = this.strToDate(s);
    newDt.setDate(newDt.getDate() + d);
    return this.formatDate(newDt, f || "yyyymmdd");
  },

  //입력받은 일자에 대해서 해당 개월수만큼 더한 일자 반환. 마이너스 개월수는 입력받은 일자보다 이전 일자로 계산해서 반환
  addMonths: function (s, m, f) {
    if (!this.isDate(s) || !_.isNumber(m)) return "";
    var newDt = this.strToDate(s);
    newDt.setMonth(newDt.getMonth() + m);
    return this.formatDate(newDt, f || "yyyymmdd");
  },

  //입력받은 일자에 대해서 해당 년수만큼 더한 일자 반환. 마이너스 년수는 입력받은 일자보다 이전 일자로 계산해서 반환
  addYears: function (s, y, f) {
    if (!this.isDate(s) || !_.isNumber(y)) return "";
    var newDt = this.strToDate(s);
    newDt.setFullYear(newDt.getFullYear() + y);
    return this.formatDate(newDt, f || "yyyymmdd");
  },

  //입력받은 일자에 마지막 일 반환
  getLastDay: function (s, f) {
    if (!this.isDate(s)) return "";
    var newDt = this.strToDate(s);
    newDt.setMonth(newDt.getMonth() + 1);
    newDt.setDate(0);
    return this.formatDate(newDt, f || "yyyymmdd");
  },

  checkDateOver: function (s, f) {
    if (!this.isDate(s)) return "";

    if (s > f) {
      return false;
    }

    return true;
  },

  /**
   * 쿠키 셋팅
   */
  setCookie: function (name, value, expiredays) {
    var todayDate = new Date();
    if (expiredays == null) {
      // 쿠키가 저장될 기간을 설정 null 일경우 default 하루
      expiredays = 1;
    }
    todayDate.setDate(todayDate.getDate() + expiredays);
    document.cookie =
      name +
      "=" +
      escape(value) +
      "; path=/; expires=" +
      todayDate.toGMTString() +
      ";";
  },

  /**
   * 모바일 가상키패드 입력 object
   */
  getMobileInputEncData: function (ids, formObj) {
    var inputData = {
      ids: ids,
      transkeyUuid: mtk.transkeyUuid,
    };
    var isMakeEncData = false;
    var idsBuf = "";
    for (var i = 0; i < ids.length; i++) {
      var id = ids[i];

      //가상키패드일경우
      var values = mtk.inputFillEncData(document.getElementById(id)); //inputFillEncData 로직 태워서 전송해야 함
      var name = document.getElementById(id).name;
      var hidden = values.hidden;
      var hmac = values.hmac;
      inputData["name_" + id] = name;
      inputData["hidden_" + id] = hidden;
      inputData["hmac_" + id] = hmac;

      // inputData["Tk_" + id + "_checkbox"] = 'transkey';
    }
    return inputData;
  },

  /**
   * 쿠키 가져오기
   */
  getCookie: function (name) {
    var nameOfCookie = name + "=";
    var x = 0;
    while (x <= document.cookie.length) {
      var y = x + nameOfCookie.length;
      if (document.cookie.substring(x, y) == nameOfCookie) {
        if ((endOfCookie = document.cookie.indexOf(";", y)) == -1)
          endOfCookie = document.cookie.length;
        return unescape(document.cookie.substring(y, endOfCookie));
      }
      x = document.cookie.indexOf(" ", x) + 1;
      if (x == 0) break;
    }
    return "";
  },

  //NumberUtil
  strToInt: function (s) {
    if (!_.isString(s)) return 0;
    return this.parseInt(s, 10);
  },

  parseInt: function (s) {
    return this.parseInt(s, 10);
  },

  //입력된 이메일주소가 유효한이메일주소인지 검증한다.
  isEmail: function (s) {
    if (!_.isString(s)) return false;
    return /^([0-9a-zA-Z]+)([0-9a-zA-Z\._-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,3}$/.test(
      s
    );
    //return /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/.test(s);
  },

  phoneFormat: function (val) {
    if (this.isNull(val)) {
      return "";
    }

    val = replaceAll(val, "-", "");

    if (val.length == 12) {
      var val =
        val.substring(0, 4) +
        "-" +
        val.substring(4, 8) +
        "-" +
        val.substring(8, 12);
      return val;
    }

    return val.replace(
      /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
      "$1-$2-$3"
    );
  },

  replaceNum: function (str) {
    return str.replace(/[^0-9]/g, "");
  },

  cf_GetJuminToBirth: function (sJumin) {
    var sJuminBirth = sJumin.substring(0, 6);
    var sGubun = sJumin.substring(6, 7);
    if (sGubun == "1" || sGubun == "2" || sGubun == "5" || sGubun == "6") {
      sJuminBirth = "19" + sJuminBirth;
    } else if (
      sGubun == "3" ||
      sGubun == "4" ||
      sGubun == "7" ||
      sGubun == "8"
    ) {
      sJuminBirth = "20" + sJuminBirth;
    } else if (sGubun == "9" || sGubun == "0") {
      sJuminBirth = "18" + sJuminBirth;
    } else if (sGubun == "A" || sGubun == "B") {
      //태아의 경우
      sJuminBirth = "20" + sJuminBirth;
    } else if (
      sGubun == "G" ||
      sGubun == "H" ||
      sGubun == "K" ||
      sGubun == "L"
    ) {
      //미식별외국인 , 미식별내국인 중 ( 1999년생이전 )
      sJuminBirth = "19" + sJuminBirth;
    } else if (
      sGubun == "I" ||
      sGubun == "J" ||
      sGubun == "M" ||
      sGubun == "N"
    ) {
      //미식별외국인 , 미식별내국인 중 ( 2000년생이후 )
      sJuminBirth = "20" + sJuminBirth;
    }
    return sJuminBirth;
  },

  getDocCode: function (ctnsKdCd) {
    let docMap = {
      100304: "CTLA0001", // 청약서
      100756: "CTLA0003", // 알릴의무
      113113: "CTLA0064", // 알릴의무(단체명세) : [T1407170026, 20140801]단체보험 업무요건 송부
      "000364": "CTLA0017", // 상품설명서 수령확인서
      "000363": "CTLA0027", // 가입자 유의사항
      "000512": "CTLA0040", // 비교안내문
      100739: "CTLA0018", // 계약체결/이행용 동의서(동일용)
      100738: "CTLA0019", // 계약체결/이행용 동의서(다수용)
      100741: "CTLA0022", // 상품소개용 동의서(동일용)
      100740: "CTLA0023", // 상품소개용 동의서(다수용)
      100732: "CTLA0021", // 사전조회동의서
      "000508": "CTLA0026", // 실손담보계약 조회내역서
      "000509": "CTLA0028", // 정액담보계약 조회내역서
      "000499": "CTLA0008", // 피보험자명세서
      "000506": "CTLA0009", // 단체보험 약정서
      "000507": "CTLA0010", // 위험실사보고서
      100744: "CTLA0032", // e알리미신청서
      100735: "CTLG0004", // 보험업무처리용 동의서
      "000510": "CTLA0038", // 외국인모집면담보고서
      "000505": "CTLA0004", // 특별조건부특약(인수)신청서 [부보장동의서]
      "000511": "CTLA0039", // 이륜차부보장동의서, 이륜차부보장내역서
      100887: "CTLA0047", // (구서류)화재배상책임보험안내사항
      100947: "CTLA0046", // 일반보험가입설계서
      100946: "CTLA0045", // 소방청안내장
      112534: "CTLA0053", // 민원사항안내
      112536: "CTLA0054", // 건설기계직업종사자 확인서
      112599: "CTLA0055", // 간편심사 및 보험료 납입에 대한 계약자 확인서
      112636: "CTLA0057", // 특별조건부 특약가입신청서(할증)
      112502: "CTLA0056", // 지정대리청구인 동의서
      112679: "CTLA0058", // 연금저축보험 가입동의서
      112737: "CTLA0060", // 의료수급권대상자
      112749: "CTLA0013", // 다자녀 할인
      112331: "CTLA0051", // 인감증명서
      "000506": "CTLA0009", // 단체보험약정서
      112951: "CTLA0061", // FATCA 개인 (청약)
      112952: "CTLA0062", // FATCA 법인 (청약)
      114420: "CTLA0078", // CRS 개인 (청약)
      114410: "CTLA0079", // CRS 법인 (청약)
      113113: "CTLA0064", // 계약전알릴의무사항(단체명세)
      113299: "CTLA0066", // 노사(단체)합의서
      114576: "CTLA0084", // 간편심사 계약자 확인서
      114577: "CTLA0085", // 실손의료비보험(계약전환) 안내사항
      114879: "CTLA0088", // 상품 가입에 대한 계약자 확인서(해지환급금50%지급형, 해지환급금미지급형)
      115426: "CTLA0094", // 실손보험 계약전환용 비교안내 확인서 20170401 제도개정
      116007: "CTLA0030", // 전자서명 동의서
      100887: "CTLA0048", // 화재배상책임보험안내사항
      116401: "CTLA0103", // 실손의료보험안내서(유병력자실손)
      116402: "CTLA0104", // 계약자 확인서(유병력자실손)
      116957: "CTLA0114", // 장애인 전용보험 전환 관련 서류 안내문
      116314: "CTLA0101", // 영업담당자확인서
      119178: "CTLA0121", // 금융소비자에 대한 추가설명확인서
      119822: "CTLA0130", // 상품가입에 대한 계약자 확인서(독립특약 전용)
      119827: "CTLA0131", // 상품가입에 대한 계약자 확인서(독립특약 전용)
      119828: "CTLA0132", // 상품가입에 대한 계약자 확인서(독립특약 전용)
      119829: "CTLA0133", // 상품가입에 대한 계약자 확인서(독립특약 전용)
      120638: "CTLA0134", // 바이오인증 체결 동의서
      113356: "CTLA0122", // 알릴의무
      119570: "CTLA0125", // 119570 계약서류 수령확인서
      119594: "CTLA0126", // 119594 전문금융소비자 여부 확인서
      119698: "CTLA0129", // 119698 무사고 확인서
    };

    return docMap[ctnsKdCd];
  },

  fillDocCode: function (list) {
    _.each(list, (d) => {
      d.docCode = this.getDocCode(d.ctnsKdCd);
    });
  },
  saveLog: function (scrnWrkDid, dtlCon) {
    let sParam = {};
    sParam.scrnWrkDid = scrnWrkDid;
    sParam.dtlCon = dtlCon;
    if (window.location.hash.length > 0) {
      var hash = window.location.hash;
      sParam.screenId = hash.substring(2, hash.length);
    }
    axios.json("/logHisLdg.do", sParam).then(function (result) {
      // 로그생성 성공
      if (result.data.setLog === "Y") {
        console.log("set Log"); // 삭제예정(not to do)
      }
    });
  },
};
